<template>
	<div v-if="!interfaces[0]" class="height-100 flex-centerize">
		<Loader small />
	</div>
	<EditConfigurationInterface
		:widget="widget"
		v-on="$listeners"
		v-else-if="editMode"
		ref="edit_configuration_interface"
		:configurationId="configurationId"
		:interfaceId="interfaces[0].interface.id"
		:isGeneralConfiguration="isGeneralConfiguration"
	/>
	<FillConfigurationInterface
		v-else
		:widget="widget"
		v-on="$listeners"
		ref="configuration_interface"
		:configurationId="configurationId"
		:interfaceId="interfaces[0].interface.id"
		:isGeneralConfiguration="isGeneralConfiguration"
	/>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import EditConfigurationInterface from './EditConfigurationInterface';
import FillConfigurationInterface from './FillConfigurationInterface';
import Loader from '@/components/common/Loader';
import AppTabsService from '@/components/common/app-tabs-service';
import { editedWorkflowVersion } from '@/store/modules/selectedWorkflow/getters';
import { initWidgetFields } from '@/store/modules/widgetEditor/actions';
import { getConfiguration } from '@/store/modules/workflowConfigurations/getters';

const buildInterfaceRefKey = (interfaceId) => `interface-${interfaceId}`;
const mapInterfaceToTabObject = (confInterface, index) =>
	AppTabsService.getTabItem(
		`interface-${confInterface.id}`,
		confInterface.interface.widget_title ? confInterface.interface.widget_title : `Interface #${index + 1}`,
		EditConfigurationInterface,
		{
			interfaceId: confInterface.interface.id,
			ref: buildInterfaceRefKey(confInterface.interface),
		}
	);

export default {
	name: 'EditConfiguration',
	components: {
		Loader,
		EditConfigurationInterface,
		FillConfigurationInterface,
	},
	props: {
		widget: { type: Object },
		editMode: { type: Boolean },
		configurationId: { type: Number },
		isGeneralConfiguration: { type: Boolean },
	},
	computed: {
		...mapGetters([getConfiguration.fullPath, editedWorkflowVersion.fullPath]),
		configuration() {
			return this[getConfiguration.fullPath](this.configurationId);
		},
		interfaces() {
			return this.configuration?.workflow_configuration_interfaces || [];
		},
		tabs() {
			return this.interfaces.map(mapInterfaceToTabObject);
		},
	},
	methods: {
		...mapActions([initWidgetFields.fullPath]),
		focusOnInterface() {
			const curInterfaceId = this.interfaces[this.curTab].interface.id;
			this[initWidgetFields.fullPath]({ id: curInterfaceId, workflowVersionId: this[editedWorkflowVersion.fullPath].id });
		},
		addNewBlock() {
			// Triggered from parent
			this.$refs.edit_configuration_interface.addNewBlock();
		},
	},
	data() {
		return { curTab: 0, loadingAddInterface: false };
	},
	mounted() {},
	watch: {
		curTab: {
			handler() {
				this.focusOnInterface();
			},
		},
	},
};
</script>

<style lang="scss" scoped></style>
